<div class="overlay">
  <mat-spinner diameter="32" color="primary"></mat-spinner>
</div>
